import {
  EXPORT_CLEAR_STATE,
  FETCH_EXPORT_OPTIONS,
  FETCH_EXPORT_OPTIONS_FAILURE,
  FETCH_EXPORT_OPTIONS_SUCCESS,
  HIDE_EXPORT_DIALOG,
  SHOW_EXPORT_DIALOG,
} from '@Pages/RetroSynthesis/ExportRoute/constants';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import first from 'lodash/first';
import ExportRequestManager from '@Services/ExportRequestManager';

const genericExportType = 'genericExport';

export const showExportDialog = () => {
  return { type: SHOW_EXPORT_DIALOG, payload: ExportRequestManager.isBusy(genericExportType) };
};
export const hideExportDialog = () => ({ type: HIDE_EXPORT_DIALOG });
export const cleanState = () => ({ type: EXPORT_CLEAR_STATE });

export const fetchExportOptions = (reactions) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_EXPORT_OPTIONS });
    try {
      const response = await MessageBroker.send(RequestUrls.exportSpOutputOptions, { reactions });
      const { tabs } = response.outputPlanner;
      const reactionTab = first(tabs.filter((tab) => tab.value === 'SynthesisPlan'));
      const documentsTab = first(tabs.filter((tab) => tab.value === 'Citations'));
      const payload = {
        tabs: [reactionTab, documentsTab],
        citationEntities: response.citationEntities,
        reactionsEntities: response.reactionsEntities,
      };
      dispatch({ type: FETCH_EXPORT_OPTIONS_SUCCESS, payload });
    } catch (error) {
      dispatch({ type: FETCH_EXPORT_OPTIONS_FAILURE, payload: error });
    }
  };
};

export const exportRoute = (params) => {
  const trackingContent = {};
  ExportRequestManager.sendExportRequest(genericExportType, params, trackingContent);
  return { type: HIDE_EXPORT_DIALOG };
};
